import React from "react";
import SVG from "react-inlinesvg";
import { Link } from "react-router";

/**
 * A tile's description with exactly one closing full stop: one is added only
 * when the text does not already end with ".", "!" or "?" (most descriptions,
 * and every translated one, already do). No description shows nothing.
 * @param {string} description - The tile's description.
 * @returns {string} The description as shown.
 */
const withFullStop = (description) => {
  const text = String(description ?? "").trim();
  return !text || /[.!?]$/.test(text) ? text : `${text}.`;
};

/**
 * One settings tile: icon, linked title and a one-line description.
 * @param {{title: string, url: string, description: string, svgPath: string}} props - Tile content.
 * @returns {JSX.Element} The tile.
 */
const Card = ({ title, url, description, svgPath , id }) => {
    return (
      
          <div className="card card-custom card-stretch gutter-b">
              <div className="card-body">
                  <div className="d-flex align-items-center ">
                      <div className="symbol symbol-40 symbol-light-primary mr-5">
                          <span className="symbol-label">
                              <span className="svg-icon svg-icon-lg svg-icon-primary">
                                  <SVG className="h-75 align-self-end" src={ svgPath }></SVG>
                              </span>
                          </span>
                      </div>
                      <div className="d-flex flex-column font-weight-bold">
                          <Link to={url}>{title}</Link>
                          <span className="text-muted">{withFullStop(description)}</span>
                      </div>
                  </div>
              </div>
          </div>
       
    );
};

export default Card;

